<template>
  <div>

    <UnitReportComp></UnitReportComp>
<br>
    <UnitDecorationComp></UnitDecorationComp>

  </div>

</template>

<script>
import UnitDecorationComp from './UnitDecorationComp'
import UnitReportComp from './UnitReportComp'

export default {
  name: "UnitGeneralComp",
  components:{
    UnitReportComp,
    UnitDecorationComp
  },
  computed: {

  },
  methods: {

  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/admin/UnitGeneralComp.vue